import React, { Component } from 'react';
import { flatten, cloneDeep } from 'lodash';

import {
  UPDATE,
  GET_LIST,
  translate,
  showNotification as showNotificationAction,
} from 'admin-on-rest';
import { connect } from 'react-redux';
import DragHandleIcon from 'material-ui/svg-icons/editor/drag-handle';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-upward';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-downward';

import {
  SortableHandle,
  sortableContainer,
  sortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import { CircularProgress, ListItem, List, SelectField, MenuItem, Dialog } from 'material-ui';

import { getTranslationByLocale } from '../../utils/TranslationUtils';
import './styles.css';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const DragHandle = SortableHandle(() => (
  <span className="product-list-handle">
    <DragHandleIcon />
  </span>
));

const SortableItem = sortableElement(
  ({ i, value, moveToTop, moveToBottom, market }) => (
    <div className={`product-list-item ${value.markets.some((m) => m.suggestedPrice && m.countryCode === market) ? '' : 'hidden'}`}>
      <DragHandle />
      <span className="label">
        {value.internalName} {i}
      </span>
      <button className="move-in-list" onClick={moveToTop}>
        <ArrowUp />
        TOP
      </button>
      <button className="move-in-list" onClick={moveToBottom}>
        <ArrowDown />
        BOTTOM
      </button>
    </div>
  )
);

const SortableContainer = sortableContainer(({ children }) => (
  <ul className="product-list">{children}</ul>
));

class SortableComponent extends Component {
  constructor() {
    super();
    this.state = { categories: [], market: 'SE' };
  }

  componentWillMount = () => {
    restClient(GET_LIST, 'categories', {
      sort: {},
      pagination: {},
      filter: {},
    }).then((categories) => this.setState({ categories: categories.data }));
    restClient(GET_LIST, 'position-matrices', {
      sort: {},
      pagination: {},
      filter: { model: 'product' },
    }).then((matrix) => this.setState({ matrix: matrix.data[0].items }));
    restClient(GET_LIST, 'markets', {
      sort: {},
      pagination: {},
      filter: {},
    }).then((res) => this.setState({ markets: res.data }));
  };

  componentWillReceiveProps = (nextProps) => {
    if (this.props.ids.length === nextProps.ids.length) return;
    const { ids, data } = nextProps;
    const { categories } = this.state;
    const products = ids.map((id) => data[id]);

    const items = this.mapProductsToCategories(categories, products);
    this.setState({ categories: items });
  };

  onSortEnd = ({ oldIndex, newIndex, collection: categoryIndex }) => {
    const { categories, matrix } = this.state;
    const oldCategories = cloneDeep(categories);

    const sourceIndex = matrix.findIndex(
      (code) => code === oldCategories[categoryIndex].products[oldIndex].code
    );
    const targetIndex = matrix.findIndex(
      (code) => code === oldCategories[categoryIndex].products[newIndex].code
    );

    categories[categoryIndex].products = arrayMove(
      categories[categoryIndex].products,
      oldIndex,
      newIndex
    );
    this.setState({ categories });

    restClient(UPDATE, 'position-matrices', {
      id: 'product',
      data: {
        sourceIndex,
        targetIndex,
        source: oldCategories[categoryIndex].products[oldIndex].code,
        target: oldCategories[categoryIndex].products[newIndex].code,
      },
    }).then((res) =>
      this.setState({ matrix: res.data.items }, () => {
        if (res.data.success) {
          this.props.showNotification(this.props.translate('changedOrder'));
        } else {
          this.props.showNotification(this.props.translate('failedToChangeOrder'), 'warning');
          if (!this.state.loadingProducts) {
            this.getProducts();
          }
        }
      })
    );
  };

  getProducts = () =>
    this.setState(
      { loadingProducts: true },
      () => restClient(GET_LIST, 'products', {
        sort: {},
        pagination: {},
        filter: {},
      }).then((res) =>
        this.setState((state) => ({
          loadingProducts: false,
          categories: this.mapProductsToCategories(state.categories, res.data),
        }))
      ).catch(() => this.setState({ failedToLoadProducts: true }))
    );

  moveToTop = (collection, oldIndex) =>
    this.onSortEnd({ oldIndex, newIndex: 0, collection });

  moveToBottom = (collection, oldIndex) =>
    this.onSortEnd({
      oldIndex,
      newIndex: this.state.categories[collection].products.length - 1,
      collection,
    });

  repair = () =>
    restClient(UPDATE, 'position-matrices', {
      id: 'product',
      data: {
        items: flatten(this.state.categories.map((c) => c.products)).map(
          (product) => product.code
        ),
      },
    });

  mapProductsToCategories = (categories, products) =>
    categories
      ? categories.map((category) => ({
        ...category,
        products: products.filter(
          (product) => product.category.code === category.code
        ),
      }))
      : [];

  filterByMarket = (e, i, value) => this.setState({ market: value });

  render() {
    const { categories, markets, market, loadingProducts, failedToLoadProducts } = this.state;
    const { ids, locale } = this.props;

    return (
      <div>
        <Dialog open={loadingProducts}>
          {failedToLoadProducts ? (
            'Loading failed, reload and try again'
          ) : (
            'Oof, hold on, then try again'
          )}
          &nbsp;
          &nbsp;
          <CircularProgress />
        </Dialog>
        <div style={{ padding: '1em' }}>
          <SelectField
            className="market-filter"
            value={market}
            onChange={this.filterByMarket}
            floatingLabelText={translate('market')}
            fullWidth
          >
            {markets && markets.map((m) => (
              <MenuItem
                key={m.id}
                value={m.countryCode}
                primaryText={getTranslationByLocale(m.title, locale)}
              />
            ))}
          </SelectField>
        </div>
        {/* {user && user.superUser && user.phoneNumber === '16505553434' && (
          <FlatButton label="repair" onClick={this.repair} />
        )} */}
        <SortableContainer useDragHandle onSortEnd={this.onSortEnd}>
          {categories &&
            categories.map((category, categoryIndex) =>
              ids && ids.length ? (
                category.products && category.products.length ? (
                  <List key={category.id}>
                    <ListItem
                      className="category-item"
                      primaryText={getTranslationByLocale(
                        category.title,
                        locale
                      )}
                      primaryTogglesNestedList
                      nestedItems={
                        category.products.length
                          ? category.products.map((product, index) => (
                            <SortableItem
                              key={product.code}
                              collection={categoryIndex}
                              index={index}
                              i={index}
                              market={market}
                              value={product}
                              moveToTop={() =>
                                this.moveToTop(categoryIndex, index)
                              }
                              moveToBottom={() =>
                                this.moveToBottom(categoryIndex, index)
                              }
                            />
                          ))
                          : []
                      }
                    />
                  </List>
                ) : null
              ) : (
                <List key={`loading-${category.id}`}>
                  <ListItem
                    className="category-item"
                    primaryText={getTranslationByLocale(category.title, locale)}
                    open
                    nestedItems={[
                      <div
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <CircularProgress />
                      </div>,
                    ]}
                  />
                </List>
              )
            )}
        </SortableContainer>
      </div>
    );
  }
}

export default connect(
  (state) => state,
  {
    showNotification: showNotificationAction,
  }
)(translate(SortableComponent));
